import Vue from 'vue';
import VueRouter from 'vue-router';
import Vuex from '@/store';
import Home from '../views/Home.vue';
// 登录
import Login from '../views/login/login.vue';
// 404
import NotFound from '../views/404/index.vue';
// 统计
import StatisticsView from '../views/statistics/index.vue';
import Statistics from '../views/statistics/statistics.vue';
// 账号管理
import AccountView from '../views/account/index.vue';
import AccountList from '../views/account/list.vue';
import AccountCreate from '../views/account/create.vue';
import AccountDetails from '../views/account/details.vue';
// 机构管理
import AgencyView from '../views/agency/index.vue';
import AgencyList from '../views/agency/list.vue';
import AgencyCreate from '../views/agency/create.vue';
import AgencyDetails from '../views/agency/details.vue';
// 学员管理
import StudentView from '../views/student/index.vue';
import StudentList from '../views/student/list.vue';
import StudentDetails from '../views/student/details.vue';
// 证书管理
import CertView from '../views/cert/index.vue';
import CertList from '../views/cert/list.vue';
import CourseOfflineList from '../views/cert/courseOfflineList.vue';
import CertDetails from '../views/cert/details.vue';

// 报名管理
import RegistrationView from '../views/registration/index.vue';
import RegistrationList from '../views/registration/list.vue';
import RegistrationCreate from '../views/registration/create.vue';
import RegistrationVideoReviewList from '../views/registration/videoReview/list.vue';
import RegistrationProcessList from '../views/registration/process/list.vue';

// 广告管理
import AdvertisingView from '../views/advertising/index.vue';
import AdvertisingList from '../views/advertising/list.vue';
import AdvertisingCreate from '../views/advertising/create.vue';
// 分销系统
import DistributionView from '../views/distribution/index.vue';
import DistributionList from '../views/distribution/list.vue';
import DistributionAgencyList from '../views/distribution/agencyList.vue';
import DistributionStudentList from '../views/distribution/studentList.vue';
import DistributionTeacherList from '../views/distribution/teacherList.vue';
import DistributionVideoReviewList from '../views/distribution/videoReviewList.vue';
import DistributionDetails from '../views/distribution/details.vue';

// 积分商城
import PointsView from '../views/points/index.vue';
import PointsList from '../views/points/agencyList.vue';
import ProductList from '../views/points/productList.vue';
import ProductOrderList from '../views/points/orderList.vue';
import AgencyPointsDetails from '../views/points/agencyPointsDetails.vue';
// 辅导员列表
import CounselorView from '../views/counselor/index.vue';
import CounselorList from '../views/counselor/list.vue';
import CounselorCreate from '../views/counselor/create.vue';
// 系统设置
import ConfigView from '../views/config/index.vue';
import ConfigPurchase from '../views/config/purchase/info.vue';
import ConfigPurchaseEdit from '../views/config/purchase/edit.vue';
import ConfigExam from '../views/config/examination/info.vue';
import ConfigExamEdit from '../views/config/examination/edit.vue';
import ConfigQuestionExam from '../views/config/questionExam/info.vue';
import ConfigQuestionExamEdit from '../views/config/questionExam/edit.vue';
import ConfigVideoExam from '../views/config/videoExam/info.vue';
import ConfigVideoExamEdit from '../views/config/videoExam/edit.vue';
import ConfigHotSearch from '../views/config/hotSearch/index.vue';
import ConfigSupport from '../views/config/support/index.vue';
import ConfigReason from '../views/config/reason/index.vue';
import ConfigEvaluation from '../views/config/evaluation/info.vue';
import ConfigEvaluationEdit from '../views/config/evaluation/edit.vue';
// 课程管理
import CourseView from '../views/course/index.vue';
import CourseCategoryList from '../views/course/categoryList.vue';
import CourseList from '../views/course/list.vue';
import ObsoleteList from '../views/course/form/schedule/obsolete.vue';
import CourseDetails from '../views/course/details.vue';
import CourseCreate from '../views/course/create.vue';
// 直播管理
import LiveView from '../views/live/index.vue';
import LiveList from '../views/live/list.vue';
import LiveDetails from '../views/live/details.vue';

// 测试题管理
import TestView from '../views/test/index.vue';
import TestList from '../views/test/list.vue';

// 订单管理
import OrderView from '../views/order/index.vue';
import OrderList from '../views/order/list.vue';
import OrderDetails from '../views/order/details.vue';

// 测评宝
import EvaluationView from '../views/evaluation/index.vue';
import EvaluationList from '../views/evaluation/list.vue';
import EvaluationStatistics from '../views/evaluation/statistics/statistics.vue';
import EvaluationCreate from '../views/evaluation/create.vue';
import EvaluationDetails from '../views/evaluation/details.vue';
import EvaluationQuestionList from '../views/evaluation/question/list.vue';
import EvaluationPurchaseHistoryList from '../views/evaluation/purchase-history/list.vue';

// 优惠券
import CouponView from '../views/coupon/index.vue';
import CouponList from '../views/coupon/list.vue';
import CouponuUserList from '../views/coupon/user/list.vue';

// 代理商
import AgentView from '../views/agent/index.vue';
import AgentList from '../views/agent/list.vue';
import AgentStatistics from '../views/agent/statistics/statistics.vue';
import AgentDetails from '../views/agent/details.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '*',
    name: 'NotFound',
    component: NotFound,
    meta: {
      title: '无法找到的页面',
    },
  },
  {
    path: '/',
    name: 'Home',
    component: Home,
    redirect: '/course',
    children: [
      {
        path: 'statistics',
        name: 'StatisticsView',
        component: StatisticsView,
        redirect: 'statistics/overview',
        meta: {
          title: '数据统计',
          id: 1,
        },
        children: [
          {
            path: 'overview',
            name: 'Statistics',
            component: Statistics,
            meta: {
              title: '统计数据',
              id: 2,
            },
          },
        ],
      },
      {
        path: 'account',
        name: 'AccountView',
        component: AccountView,
        redirect: 'account/list',
        meta: {
          title: '账号管理',
        },
        children: [
          {
            path: 'list',
            name: 'AccountList',
            component: AccountList,
            meta: {
              title: '账号列表',
              id: 4,
            },
          },
          {
            path: 'create/:id?',
            name: 'AccountCreate',
            component: AccountCreate,
            meta: {
              title: '新增账号',
              activeMenu: '',
              id: 5,
            },
          },
          {
            path: 'details/:id',
            name: 'AccountDetails',
            component: AccountDetails,
            meta: {
              title: '账号详情',
              activeMenu: '',
              id: null,
              hideMenu: true,
            },
          },
        ],
      },
      {
        path: 'agency',
        name: 'AgencyView',
        component: AgencyView,
        redirect: 'agency/list',
        meta: {
          title: '机构管理',
          id: null,
        },
        children: [
          {
            path: 'list',
            name: 'AgencyList',
            component: AgencyList,
            meta: {
              title: '机构列表',
              id: 7,
            },
          },
          {
            path: 'create/:id?',
            name: 'AgencyCreate',
            component: AgencyCreate,
            meta: {
              title: '新增机构',
              id: 8,
            },
          },
          {
            path: 'details/:id',
            name: 'AgencyDetails',
            component: AgencyDetails,
            meta: {
              title: '机构详情',
              hideMenu: true,
            },
          },
        ],
      },
      {
        path: 'eavluation',
        name: 'EvaluationView',
        component: EvaluationView,
        redirect: 'eavluation/list',
        meta: {
          title: '测评宝管理',
          id: null,
          isHidden: true,
        },
        children: [
          {
            path: 'statistics',
            name: 'Statistics',
            component: EvaluationStatistics,
            meta: {
              title: '统计',
              id: 53,
            },
          },
          {
            path: 'list',
            name: 'EvaluationList',
            component: EvaluationList,
            meta: {
              title: '行业列表',
              id: 53,
            },
          },
          {
            path: 'create/:id?',
            name: 'EvaluationCreate',
            component: EvaluationCreate,
            meta: {
              title: '新建行业',
              hideMenu: true,
              id: null,
            },
          },
          {
            path: 'details/:id',
            name: 'EvaluationDetails',
            component: EvaluationDetails,
            meta: {
              title: '行业详情',
              hideMenu: true,
            },
          },
          {
            path: 'question-list',
            name: 'EvaluationQuestionList',
            component: EvaluationQuestionList,
            meta: {
              title: '测评宝试题列表',
              id: 54,
            },
          },
          {
            path: 'purchase-history-list',
            name: 'EvaluationPurchaseHistoryList',
            component: EvaluationPurchaseHistoryList,
            meta: {
              title: '购买记录',
              id: 55,
            },
          },
        ],
      },
      {
        path: 'coupon',
        name: 'CouponView',
        component: CouponView,
        redirect: 'coupon/list',
        meta: {
          title: '优惠券管理',
          id: null,
        },
        children: [
          {
            path: 'list',
            name: 'CouponList',
            component: CouponList,
            meta: {
              title: '优惠券列表',
              id: 57,
            },
          },
          {
            path: 'user/list',
            name: 'CouponuUserList',
            component: CouponuUserList,
            meta: {
              title: '用户优惠券列表',
              id: 58,
            },
          },
        ],
      },
      {
        path: 'agent',
        name: 'AgentView',
        component: AgentView,
        redirect: 'agent/list',
        meta: {
          title: '代理商管理',
          id: 59,
        },
        children: [
          {
            path: 'statistics',
            name: 'AgentStatistics',
            component: AgentStatistics,
            meta: {
              title: '统计',
              id: 61,
            },
          },
          {
            path: 'list',
            name: 'AgentList',
            component: AgentList,
            meta: {
              title: '代理商列表',
              id: 60,
            },
          },
          {
            path: 'details/:id',
            name: 'AgentDetails',
            component: AgentDetails,
            meta: {
              title: '代理商详情',
              hideMenu: true,
            },
          },
        ],
      },
      {
        path: 'student',
        name: 'StudentView',
        component: StudentView,
        redirect: 'student/list',
        meta: {
          title: '学员管理',
          id: null,
        },
        children: [
          {
            path: 'list',
            name: 'StudentList',
            component: StudentList,
            meta: {
              title: '学员列表',
              id: 10,
            },
          },
          {
            path: 'details/:id',
            name: 'StudentDetails',
            component: StudentDetails,
            meta: {
              title: '学员详情',
              id: null,
              hideMenu: true,
            },
          },
        ],
      },
      {
        path: 'registration',
        name: 'RegistrationView',
        component: RegistrationView,
        redirect: 'registration/list',
        meta: {
          title: '报名管理',
        },
        children: [
          {
            path: 'list',
            name: 'RegistrationList',
            component: RegistrationList,
            meta: {
              title: '报名列表',
              id: 12,
            },
          },
          {
            path: 'create/:id?',
            name: 'RegistrationCreate',
            component: RegistrationCreate,
            meta: {
              title: '新增报名',
              id: null,
            },
          },
          {
            path: 'video-list',
            name: 'RegistrationVideoReviewList',
            component: RegistrationVideoReviewList,
            meta: {
              title: '考试审核列表',
              id: 13,
            },
          },
          {
            path: 'process-list',
            name: 'RegistrationProcessList',
            component: RegistrationProcessList,
            meta: {
              title: '考试进度列表',
              id: 50,
            },
          },
        ],
      },
      {
        path: 'advertising',
        name: 'AdvertisingView',
        component: AdvertisingView,
        redirect: 'advertising/list',
        meta: {
          title: '广告管理',
        },
        children: [
          {
            path: 'list',
            name: 'AdvertisingList',
            component: AdvertisingList,
            meta: {
              title: '广告列表',
              id: 24,
            },
          },
          {
            path: 'create/:id?',
            name: 'AdvertisingCreate',
            component: AdvertisingCreate,
            meta: {
              title: '广告新增',
              id: 24,
            },
          },
        ],
      },
      {
        path: 'distribution',
        name: 'DistributionView',
        component: DistributionView,
        redirect: 'distribution/list',
        meta: {
          title: '平台分销管理',
        },
        children: [
          {
            path: 'list',
            name: 'DistributionList',
            component: DistributionList,
            meta: {
              title: '平台分销记录',
              id: 26,
            },
          },
          {
            path: 'agency-list',
            name: 'DistributionAgencyList',
            component: DistributionAgencyList,
            meta: {
              title: '机构分销记录',
              id: 27,
            },
          },
          {
            path: 'agency-details/:id/:type',
            name: 'DistributionDetails',
            component: DistributionDetails,
            meta: {
              title: '分销详情',
              id: null,
              hideMenu: true,
            },
          },
          {
            path: 'teacher-list',
            name: 'DistributionTeacherList',
            component: DistributionTeacherList,
            meta: {
              title: '老师分销记录',
              id: 49,
            },
          },
          {
            path: 'student-list',
            name: 'DistributionStudentList',
            component: DistributionStudentList,
            meta: {
              title: '学员分销记录',
              id: 20,
            },
          },
          {
            path: 'video-list',
            name: 'DistributionVideoReviewList',
            component: DistributionVideoReviewList,
            meta: {
              title: '视频审核记录',
              id: 29,
            },
          },
        ],
      },
      {
        path: 'points',
        name: 'PointsView',
        component: PointsView,
        redirect: 'points/list',
        meta: {
          title: '机构积分管理',
        },
        children: [
          {
            path: 'list',
            name: 'PointsList',
            component: PointsList,
            meta: {
              title: '机构积分列表',
              id: 30,
            },
          },
          {
            path: 'agency-details/:id',
            name: 'AgencyPointsDetails',
            component: AgencyPointsDetails,
            meta: {
              title: '机构积分详情',
              id: null,
              hideMenu: true,
            },
          },
          {
            path: 'product-list',
            name: 'ProductList',
            component: ProductList,
            meta: {
              title: '商品列表',
              id: 31,
            },
          },
          {
            path: 'product-order-list',
            name: 'ProductOrderList',
            component: ProductOrderList,
            meta: {
              title: '商品订单列表',
              id: 32,
            },
          },
        ],
      },
      {
        path: 'counselor',
        name: 'CounselorView',
        component: CounselorView,
        redirect: 'counselor/list',
        meta: {
          title: '辅导员管理',
        },
        children: [
          {
            path: 'list',
            name: 'CounselorList',
            component: CounselorList,
            meta: {
              title: '辅导员列表',
              id: 38,
            },
          },
          {
            path: 'create/:id?',
            name: 'CounselorCreate',
            component: CounselorCreate,
            meta: {
              title: '新增辅导员',
              id: null,
              hideMenu: true,
            },
          },
        ],
      },
      {
        path: 'course',
        name: 'CourseView',
        component: CourseView,
        redirect: 'course/list',
        meta: {
          title: '课程管理',
        },
        children: [
          {
            path: 'category',
            name: 'CourseCategoryList',
            component: CourseCategoryList,
            meta: {
              title: '课程类型列表',
              id: 35,
            },
          },
          {
            path: 'list',
            name: 'CourseList',
            component: CourseList,
            meta: {
              title: '课程列表',
              id: 34,
            },
          },
          {
            path: 'details/:courseClassId',
            name: 'CourseDetails',
            component: CourseDetails,
            meta: {
              title: '课程详情',
              id: null,
              hideMenu: true,
            },
          },
          {
            path: 'obsolete-list',
            name: 'ObsoleteList',
            component: ObsoleteList,
            meta: {
              title: '课程表历史',
              id: null,
              hideMenu: true,
            },
          },
          {
            path: 'create/:courseClassId?',
            name: 'CourseCreate',
            component: CourseCreate,
            meta: {
              title: '新增课程',
              id: null,
              hideMenu: true,
            },
          },
        ],
      },
      {
        path: 'test',
        name: 'TestView',
        component: TestView,
        redirect: 'test/list',
        meta: {
          title: '试题管理',
        },
        children: [
          {
            path: 'list',
            name: 'TestList',
            component: TestList,
            meta: {
              title: '课程试题列表',
              id: 27,
            },
          },
        ],
      },
      {
        path: 'cert',
        name: 'CertView',
        component: CertView,
        redirect: 'cert/list',
        meta: {
          title: '证书管理',
        },
        children: [
          {
            path: 'list',
            name: 'CertList',
            component: CertList,
            meta: {
              title: '证书列表',
              id: 23,
            },
          },
          {
            path: 'course-offline-list',
            name: 'CourseOfflineList',
            component: CourseOfflineList,
            meta: {
              title: '线下课程管理',
              id: 46,
            },
          },
          {
            path: 'details/:certId',
            name: 'CertDetails',
            component: CertDetails,
            meta: {
              title: '证书详情',
              id: null,
              hideMenu: true,
            },
          },
        ],
      },
      {
        path: 'order',
        name: 'OrderView',
        component: OrderView,
        redirect: 'order/list',
        meta: {
          title: '订单管理',
        },
        children: [
          {
            path: 'list',
            name: 'OrderList',
            component: OrderList,
            meta: {
              title: '订单列表',
              id: 33,
            },
          },
          {
            path: 'details/:orderId',
            name: 'OrderDetails',
            component: OrderDetails,
            meta: {
              title: '订单详情',
              id: null,
              hideMenu: true,
            },
          },
        ],
      },
      {
        path: 'live',
        name: 'LiveView',
        component: LiveView,
        redirect: 'live/list',
        meta: {
          title: '直播管理',
        },
        children: [
          {
            path: 'list',
            name: 'LiveList',
            component: LiveList,
            meta: {
              title: '直播列表',
              id: 36,
            },
          },
          {
            path: 'details/:id',
            name: 'LiveDetails',
            component: LiveDetails,
            meta: {
              title: '直播详情',
              id: null,
              hideMenu: true,
            },
          },
        ],
      },
      {
        path: 'config',
        name: 'ConfigView',
        component: ConfigView,
        redirect: 'config/purchase',
        meta: {
          title: '系统配置',
        },
        children: [
          {
            path: 'purchase',
            name: 'ConfigPurchase',
            component: ConfigPurchase,
            meta: {
              title: '购课须知',
              id: 39,
            },
          },
          {
            path: 'purchase-edit',
            name: 'ConfigPurchaseEdit',
            component: ConfigPurchaseEdit,
            meta: {
              title: '编辑购课须知',
              id: null,
              hideMenu: true,
            },
          },
          {
            path: 'exam',
            name: 'ConfigExam',
            component: ConfigExam,
            meta: {
              title: '考试须知',
              id: 40,
            },
          },
          {
            path: 'exam-edit',
            name: 'ConfigExamEdit',
            component: ConfigExamEdit,
            meta: {
              title: '编辑考试须知',
              id: null,
              hideMenu: true,
            },
          },
          {
            path: 'evaluation',
            name: 'ConfigEvaluation',
            component: ConfigEvaluation,
            meta: {
              title: '测评宝ICON标签',
              id: null,
            },
          },
          {
            path: 'evaluation-edit',
            name: 'ConfigEvaluationEdit',
            component: ConfigEvaluationEdit,
            meta: {
              title: '编辑测评宝ICON标签',
              id: null,
              hideMenu: true,
            },
          },
          {
            path: 'question-exam',
            name: 'ConfigQuestionExam',
            component: ConfigQuestionExam,
            meta: {
              title: '理论考试须知',
              id: 41,
            },
          },
          {
            path: 'question-exam-edit',
            name: 'ConfigQuestionExamEdit',
            component: ConfigQuestionExamEdit,
            meta: {
              title: '编辑理论考试须知',
              id: null,
              hideMenu: true,
            },
          },
          {
            path: 'video-exam',
            name: 'ConfigVideoExam',
            component: ConfigVideoExam,
            meta: {
              title: '视频考试须知',
              id: 42,
            },
          },
          {
            path: 'video-exam-edit',
            name: 'ConfigVideoExamEdit',
            component: ConfigVideoExamEdit,
            meta: {
              title: '编辑视频考试须知',
              id: null,
              hideMenu: true,
            },
          },
          {
            path: 'hot-search',
            name: 'ConfigHotSearch',
            component: ConfigHotSearch,
            meta: {
              title: '热搜查询',
              id: 43,
            },
          },
          {
            path: 'support',
            name: 'ConfigSupport',
            component: ConfigSupport,
            meta: {
              title: '咨询电话',
              id: 44,
            },
          },
          {
            path: 'reason',
            name: 'ConfigReason',
            component: ConfigReason,
            meta: {
              title: '审核失败原因',
              id: 45,
            },
          },
        ],
      },
    ],
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
  },
];

const router = new VueRouter({
  base: process.env.BASE_URL,
  mode: 'history',
  routes,
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    return { x: 0, y: 0 };
  },
});

router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('token');
  if (!Vuex.getters.user) {
    Vuex.dispatch('user', JSON.parse(localStorage.getItem('user')));
  }
  if (!token) {
    if (to.path !== '/login') {
      next({ path: '/login' });
    } else {
      next();
    }
  } else {
    next();
  }
});

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push (location) {
  return originalPush.call(this, location).catch((err) => err);
};
export default router;
export { routes };
